import Navbar from 'components/navbar'
import Layout, { Textlayout } from 'components/layout'
import Bullet from 'components/service/bullet'
import Seo from 'components/seo'
import Footer from 'components/footer'
import Cta from 'components/cta'

import { allServices, servicesHomeData } from 'data/services'
import { useMemo } from 'react'

export default function servicePage({ serviceSlug }) {
  const thisServiceData = useMemo(() => allServices[serviceSlug], [allServices, serviceSlug])
  // const doesNoOneHasConcretly = useMemo(
  //   () => thisServiceData.page.bulletpoints.every((el) => el.concretly.length === 0),
  //   [thisServiceData]
  // )

  return (
    <>
      <Seo
        title={thisServiceData.name}
        description={thisServiceData.page.metaDescription}
        canonical={`/services/${thisServiceData.slug}`}
        schema={({ fullTitle, description, url }) => ({
          '@context': 'https://schema.org',
          '@type': 'Service',
          provider: {
            '@id': 'https://ateliermilky.com#identity'
          },
          serviceType: thisServiceData.name,
          name: fullTitle,
          description: description,
          mainEntityOfPage: url
        })}
      />
      <div className="">
        <Navbar />
        <main className="mt-12 md:mt-24">
          <Layout>
            <h1 className="text-center font-serif text-4xl font-bold">{thisServiceData.name}</h1>

            <div className="mt-8">
              <Textlayout>
                <div className="space-y-4 text-justify text-lg leading-tight">{thisServiceData.description}</div>
              </Textlayout>
            </div>
          </Layout>

          <div className="mt-12 overflow-hidden">
            <Layout>
              <Textlayout>
                <div className="relative">
                  <div className={`test services-grid grid grid-cols-1 gap-8 lg:grid-cols-2`}>
                    {thisServiceData.page.bulletpoints.map((thisBullet) => (
                      <Bullet key={thisBullet.id} thisBullet={thisBullet} />
                    ))}
                  </div>
                  <div
                    aria-hidden="true"
                    className="absolute right-[-25rem] top-48 hidden h-[15rem] w-[30rem] rounded-t-full border-2 border-blue bg-transparent md:block"></div>

                  <div
                    aria-hidden="true"
                    className="absolute left-[-15rem] top-96 hidden h-[48rem] w-[24rem] rounded-r-full border-2 border-blue bg-transparent md:block"></div>
                </div>
                <div className="mt-12 flex justify-center pb-4">
                  <Cta href="/services" type="sm">
                    Les autres services
                  </Cta>
                </div>
              </Textlayout>
            </Layout>
          </div>
        </main>
        <div className="mt-32">
          <Footer />
        </div>
      </div>
      <style jsx>{`
        .services-grid {
          grid-template-rows: repeat(${thisServiceData.page.bulletpoints.length}, minmax(0, 1fr));
        }

        @media (min-width: 1024px) {
          .services-grid {
            grid-template-rows: repeat(${Math.ceil(thisServiceData.page.bulletpoints.length / 2)}, minmax(0, 1fr));
          }
        }
      `}</style>
    </>
  )
}

export async function getStaticProps(context) {
  return {
    props: {
      serviceSlug: context.params.serviceSlug
    }
  }
}

export async function getStaticPaths() {
  return {
    paths: servicesHomeData.map((thisService) => ({
      params: { serviceSlug: thisService.slug }
    })),
    fallback: false
  }
}
